import ColorPicker from '@/components/commons/color-picker';
import { POSITION } from '@/components/sections/builder/constants/position';
import { defaultData } from '@/components/sections/builder/elements/body/not-found/index';
import { NotFoundElementDataType } from '@/components/sections/builder/elements/body/not-found/type';
import BackgroundSetting from '@/components/sections/builder/settings/background-setting';
import PaddingSetting from '@/components/sections/builder/settings/padding-setting';
import SchemeSetting from '@/components/sections/builder/settings/scheme-setting';
import { ElementProps } from '@/components/sections/builder/types';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Separator } from '@/components/ui/separator';
import { useBuilderStore } from '@/stores/builder';
import { ColorResult } from 'react-color';
import { shallow } from 'zustand/shallow';

export default function NotFoundElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setElementData: state.setElementData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const data = element.data as NotFoundElementDataType;

  const onChangeColor = (
    color: ColorResult & {
      source: 'rgb' | 'hex' | 'hsl';
    }
  ) => {
    if (color.source === 'rgb') {
      builder.setElementData(element.id, {
        overlay: `rgba(${color.rgb.r},${color.rgb.g},${color.rgb.b},${color.rgb.a})`,
      });
    } else {
      builder.setElementData(element.id, { overlay: color.hex });
    }
  };

  return (
    <div>
      <h1 className='mb-4 text-sm font-bold'>Layout</h1>
      <div className='my-4 grid grid-cols-2 items-center justify-between gap-2'>
        <label className='block'>Content Position</label>
        <Select
          name='alignment'
          value={data.alignment || defaultData.alignment}
          onValueChange={(value) => builder.setElementData(element.id, { alignment: value })}
        >
          <SelectTrigger className='w-full rounded border p-2'>
            <SelectValue placeholder='Select' />
          </SelectTrigger>
          <SelectContent>
            {POSITION.map((obj) => (
              <SelectItem key={obj.value} value={obj.value}>
                {obj.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <PaddingSetting
        value={data.padding}
        onChange={(v) => builder.setElementData(element.id, { padding: v })}
      />

      <Separator className='my-4' />

      <h1 className='mb-3 text-sm font-bold'>Style</h1>
      <div className='my-4'>
        <label className=''>Container Color Scheme</label>
        <SchemeSetting
          value={data.colorScheme || defaultData.colorScheme}
          onChange={(theme) => {
            builder.setElementData(element.id, {
              colorScheme: theme,
            });
          }}
        />
      </div>

      <span className='my-4 flex'>Background</span>
      <BackgroundSetting
        label=''
        value={data.background}
        onChange={(background) =>
          builder.setElementData(element.id, {
            background,
          })
        }
      />

      <span className='my-4 flex'>Overlay</span>
      <ColorPicker
        color={data.overlay}
        inputColor={data.overlay}
        percentage={String(data.overlayOpacity) || String(defaultData.overlayOpacity)}
        onChangeColorComplete={(color) => onChangeColor(color)}
        onChangeInputColor={(e) => builder.setElementData(element.id, { overlay: e.target.value })}
        onChangePercentage={(v) =>
          builder.setElementData(element.id, { overlayOpacity: Number(v) })
        }
      />
    </div>
  );
}
